"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = require("satcheljs/lib/legacy");
var store_1 = require("../store/store");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardWeatherOption')(function discardWeatherOption(state) {
    var optionState = state.optionState;
    optionState.weatherEnabled = null;
    optionState.weatherUnit = null;
}));
//# sourceMappingURL=discardWeatherOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-weather-option/lib/actions/discardWeatherOption.js
// module id = 5247
// module chunks = 2